import { apiSlice } from '../../api/apiSlice';
import {
    CountryListParams,
    CountryListResponse,
} from './countryListApiSliceTypes';

const countryListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCountryList: builder.query<CountryListResponse, CountryListParams>({
            query: (params) => {
                return {
                    url: '/globals/countries',
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                };
            },
            providesTags: (response) => {
                return response
                    ? [
                          ...response.data.map((country) => ({
                              type: 'countries' as const,
                              id: country.id,
                          })),
                          { type: 'countries', id: 'LIST' },
                      ]
                    : [{ type: 'countries', id: 'LIST' }];
            },
        }),
    }),
    overrideExisting: true,
});

export const { useGetCountryListQuery, useLazyGetCountryListQuery } =
    countryListApiSlice;
